module.exports = __webpack_public_path__ + "static/revicons-17629a5dfe0d3c3946cf401e1895f091.ttf";